<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
      <b-card no-header>
        <template slot="header">
          <b-row>
            <b-col cols="6">
              <b-row>
                <b-col cols="12" md="6">
                  <span>Report Details</span>
                </b-col>
                <b-col cols="12" md="4">
                  <b-dropdown
                    variant="outline-primary"
                    size="sm"
                    id="dropdown-1"
                    :text="reportingName"
                  >
                    <!-- <b-dropdown-item @click="updateReport(-1)">Initial Report</b-dropdown-item> -->
                    <b-dropdown-item
                      v-for="(item,i) in reports"
                      :key="i"
                      @click="updateReport(i)"
                    >Reporting {{i+1}}</b-dropdown-item>
                  </b-dropdown>
                </b-col>
                
               
              </b-row>
            </b-col>
            <b-col cols="12" md="6" class="ml-auto text-right">
              <b-button variant="link"  @click="previous()">    <i  v-if="previousIcon"  class="fa fa-chevron-left pr-4" style="color:blue"  aria-hidden="true"></i></b-button>
          <b-button variant="link"  @click="next()">        <i v-if="nextIcon" class="fa fa-chevron-right" style="color:blue"  aria-hidden="true"></i></b-button>
                </b-col>
          </b-row>
        </template>
        <div v-if="fullReport">
          <b-row>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="8" md="5">
                  <span class="item_title">Case ID</span>
                </b-col>
                <b-col cols="4" md="7">
                  <span class="item_value">{{fullReport.caseidentifier}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="8" md="5">
                  <span class="item_title">Incident</span>
                </b-col>
                <b-col cols="4" md="7">
                  <router-link :to="'/Casedetails/'+fullReport._id">
                    <span
                      class="item_value"
                      style="font-size:14px;font-weight:500;color:#208eff"
                    > ({{fullReport.locationname}})</span>
                  </router-link>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" md="6">
               <b-row>
                <b-col cols="8" md="5">
                  <span class="item_title">Reported Date</span>
                </b-col>
                <b-col cols="4" md="7">
                  <span class="item_value">{{formatDate(report.createddate)}}</span>
                </b-col>
              </b-row>
              <hr />
               <b-row>
                <b-col cols="8" md="3">
                  <span class="item_title">Reason</span>
                </b-col>
                <b-col cols="4" md="9">
                  <span class="item_value">{{report.reason}}</span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="12">
              <span class="item_title">Photos</span>
            </b-col>
            <!-- <b-col
              cols="12"
              md="4"
              v-for="(item,i) in report.images"
              :key="i"
              align="center"
              class="py-2"
            >
              <img :src="baseURL+'/u/'+item.photo" width="auto" height="200px"  v-b-modal.modal-lg  @click="openImg(item)" />
            </b-col>
             <showImage v-if="showImg" v-bind:storage="imgModal"  @stepper="winStepper"/> -->
           <div class="card-body text-secondary">
              <div
                v-if="report.images != null && report.images.length > 0"
                style="
                  overflow-x: auto !important;
                  overflow-y: hidden !important;
                "
              >
                <div v-viewer style="display: flex">
                  <div
                    v-for="image in report.images"
                    :key="image.key"
                    style="width: 100%; max-height: 200px"
                    class="col-md-3"
                  >
                    <img
                      :src="baseURL + '/u/' + image.photo"
                      class="image"
                      style="
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        max-width: 250px;
                      "
                      :key="image.src"
                    />
                  </div>
                </div>
              </div>
            </div>
          </b-row>
          <hr />
          <!-- User Details -->
          <b-row>
            <b-col cols="12" class="py-2">
              <span class="item_title" style="font-size:18px">Incident Added By</span>
              <span class="px-2">
                <b-button
                  variant="outline-primary"
                  router-link
                  :to="'/Userdetails/'+user._id"
                  size="sm"
                >Visit Profile</b-button>
              </span>
            </b-col>
            <b-col v-if="user.photo" cols="12" class="py-2">
              <img :src="baseURL+'/u/'+user.photo" height="100px" />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Name</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.name}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Phone</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.phonePrefix}}&nbsp;{{user.phone}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Age</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.age}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Occupation</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.occupation}}</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Country</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.country}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="6" md="5">
                  <span class="item_title">Phone Verified</span>
                </b-col>
                <b-col cols="6" md="7">
                  <span class="item_value">{{user.isPhoneVerified}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Gender</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.gender}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">User ID</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.userid}}</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
          </b-row>
          <hr />

          <!-- Reported by this User -->
          <b-row>
            <b-col cols="12" class="py-2">
              <span class="px-2">
                <span class="item_title" style="font-size:18px">Reported By</span>
              </span>
              <span class="px-2">
                <b-button
                  variant="outline-primary"
                  router-link
                  :to="'/Userdetails/'+reportedBy._id"
                  size="sm"
                >Visit Profile</b-button>
              </span>
            </b-col>
            <b-col v-if="reportedBy.photo" cols="12" class="py-2">
              <img :src="baseURL+'/u/'+reportedBy.photo" height="100px" />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Name</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{reportedBy.name}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Phone</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{reportedBy.phonePrefix}}&nbsp;{{reportedBy.phone}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Age</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{reportedBy.age}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Occupation</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{reportedBy.occupation}}</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Country</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{reportedBy.country}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="6" md="5">
                  <span class="item_title">Phone Verified</span>
                </b-col>
                <b-col cols="6" md="7">
                  <span class="item_value">{{reportedBy.isPhoneVerified}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Gender</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{reportedBy.gender}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">User ID</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{reportedBy.userid}}</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
          </b-row>
          <b-row class="justify-content-center" v-if="superAdmin">
            <div class="px-2">
              <b-button
                variant="outline-primary"
                size="sm"
                @click="confirmBoxGenuine"
              >Mark as Genuine Incident</b-button>
            </div>
            <div class="px-2">
              <b-button
                v-if="fullReport.status!='falsealarm'"
                variant="outline-warning"
                size="sm"
                @click="confirmBoxSpam"
              >Mark as Spam</b-button>
            </div>
            <!-- <div class="px-2">
              <b-button
                variant="outline-danger"
                @click="confirmBoxIncident"
                size="sm"
              >Remove Incident</b-button>
            </div>-->
          </b-row>
        </div>
        <template slot="footer">
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
import locationMap from "./map";
import showImage from "./ImageViewer";
export default {
  props: ["id1", "idset"],
  components: {
    locationMap,
    showImage
  },
  data() {
    return {
       previousIcon: true,
      nextIcon: true,
      fullReport: null,
      report: null,
      user: null,
      appLoading: false,
      reportId: null,
      map: null,
      oMarker: [],
      reports: [],
      reportingName: "Reporting 1",
      reportedBy: null,
      ServerError: false,
      superAdmin: false,
      showImg: false,
      imgModal: {},
    };
  },
  beforeMount() {
    this.getData();
    // console.log(this.idset)
    if (localStorage.getItem("role") != "Sub Admin") this.superAdmin = true;
  },
  methods: {
    next() {
      // alert(this.id,this.idset)
      var temp = [];
      temp = this.idset.split(",");

      for (var j = 0; j < temp.length; j++) {
        if (this.reportId == temp[j]) {
          this.$router.push("/FalseAlarms/" + temp[j + 1] + "/" + temp);
          this.getData();
        }
      }
    },
    previous() {
      var temp = [];
      // console.log("hiil", this.idset);
      temp = this.idset.split(",");

      for (var j = 0; j < temp.length; j++) {
        if (this.reportId == temp[j]) {
          if (j != 0) {
            this.$router.push("/FalseAlarms/" + temp[j - 1] + "/" + temp);
            this.getData();
          }
        }
      }
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/incident/falsealarm/getbyincident",
        params: {
          incident: this.$route.params.id
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.fullReport = response.data.data;
          this.reports = this.fullReport.reports;
          this.report = this.reports[0];
          this.reportId = this.fullReport._id;
          
          this.user = this.fullReport.addedby;
          this.reportedBy = this.report.reportedby;
          var temp = [];
          temp = this.idset.split(",");
         
          if ( this.reportId == temp[0]) {
            this.previousIcon = false;
          } else this.previousIcon = true;
          if ( this.reportId == temp[temp.length - 1]) {
            this.nextIcon = false;
          }
          else this.nextIcon = true;
        })
        .catch(err => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    updateReport(item) {
      this.report = this.reports[item];
      this.reportId = this.report._id;
      this.reportedBy = this.report.reportedby;
      this.reportingName = "Reporting " + (1 + item);
    },
    confirmBoxGenuine() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to mark this reporting as Genuine.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(value => {
          if (value) {
            this.markGenuine();
          }
        })
        .catch(err => {
          this.ServerError = true;
        });
    },
    confirmBoxIncident() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to remove this incident.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(value => {
          if (value) {
            this.removeIncident();
          }
        })
        .catch(err => {
          this.ServerError = true;
        });
    },
    confirmBoxSpam() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to mark this incident as spam.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(value => {
          if (value) {
            this.markSpam();
          }
        })
        .catch(err => {
          this.ServerError = true;
        });
    },
    markGenuine() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/incident/falsealarm/notspam",
        data: {
          id: this.reportId
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.$router.go(-1);
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    removeIncident() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/incident/remove",
        params: {
          id: this.$route.params.id
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.$router.go(-1);
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    markSpam() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/incident/falsealarm/spam",
        data: {
          id: this.reportId
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.$router.go(-1);
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
      winStepper(window_data) {
      this.showImg=window_data.showImg
    //  this.winStep = window_data.winStep;
   },
   openImg(item) {
      this.showImg = true;
      this.imgModal = item;
      // console.log(item);
    },
  }
};
</script>